export default __webpack_public_path__ + "static/media/vid-holder-china-town-district.68c4e6f3.png";